import './ApiDocumentation.css';

const ApiDocumentation = ({ data }) => {
  if (
    !data ||
    Object.keys(data).length === 0 ||
    !data.parameters
  ) {
    return null;
  }

  const { title, parameters, description } = data;
  const { method, url, body } = parameters;

  // 🔐 Güvenli URL parser – environment değişkenleri ve relative URL'lerde patlamaz
  function extractBaseUrlAndEndpoint(rawUrl) {
    if (!rawUrl || typeof rawUrl !== "string") {
      return { baseUrl: "-", endpoint: "-" };
    }

    try {
      const parsedUrl = new URL(rawUrl);
      return {
        baseUrl: `${parsedUrl.protocol}//${parsedUrl.host}`,
        endpoint: parsedUrl.pathname || "/",
      };
    } catch (err) {
      // Örn: {{easy_stage}}/users/get-user
      const trimmed = rawUrl.trim();
      if (!trimmed) {
        return { baseUrl: "-", endpoint: "-" };
      }

      const slashIndex = trimmed.indexOf("/");
      if (slashIndex === -1) {
        // Sadece env değişkeni gibi: {{easy_stage}}
        return { baseUrl: trimmed, endpoint: "/" };
      }

      const base = trimmed.substring(0, slashIndex);
      const endpoint = trimmed.substring(slashIndex) || "/";

      return {
        baseUrl: base || "-",
        endpoint: endpoint || "-",
      };
    }
  }

  const { baseUrl, endpoint } = extractBaseUrlAndEndpoint(url);

  // body hem array hem JSON string / obje olabilir, hepsini normalize edelim
  const bodyParams = Array.isArray(body)
    ? body
    : typeof body === "string"
      ? (() => {
          try {
            const parsed = JSON.parse(body);
            if (Array.isArray(parsed)) return parsed;
            if (parsed && typeof parsed === "object") {
              return Object.entries(parsed).map(([key, value]) => ({
                key,
                type: typeof value,
                description: "",
                required: false,
              }));
            }
            return [];
          } catch {
            return [];
          }
        })()
      : body && typeof body === "object"
        ? Object.entries(body).map(([key, value]) => ({
            key,
            type: typeof value,
            description: "",
            required: false,
          }))
        : [];

  return (
    <div id="api-documentation-pdf" className="pdf-api-documentation">
      <div className="pdf-api-header">
        <h1>{title}</h1>
        <span className={`pdf-api-method ${method?.toLowerCase()}`}>
          {method?.toUpperCase()}
        </span>
      </div>

      <div className="pdf-api-url">
        <h3>Base URL:</h3>
        <code>{baseUrl}</code>
      </div>

      <div className="pdf-api-url">
        <h3>Endpoint:</h3>
        <code>{endpoint}</code>
      </div>

      {description && (
        <div className="pdf-api-description">
          <h3>Description:</h3>
          <div dangerouslySetInnerHTML={{ __html: description }} />
        </div>
      )}

      <div className="pdf-api-parameters">
        <h3>Parameters:</h3>
        <table>
          <thead>
            <tr>
              <th>Key</th>
              <th>Type</th>
              <th>Description</th>
              <th>Required</th>
            </tr>
          </thead>
          <tbody>
            {bodyParams.length > 0 ? (
              bodyParams.map((param, index) => (
                <tr key={index}>
                  <td>{param.key}</td>
                  <td>{param.type}</td>
                  <td>{param.description || '-'}</td>
                  <td>{param.required ? 'Yes' : 'No'}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={4} style={{ textAlign: 'center' }}>
                  No parameters
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ApiDocumentation;